/**
 * @packageDocumentation
 *
 * The `@rimbu/proximity/map` package provides the `ProximityMap` implementation.<br/>
 * <br/>
 * See the [Rimbu docs Map page](/docs/collections/map) for more information.
 */
import { HashMap } from '@rimbu/hashed/map';
import { DistanceFunction } from '@rimbu/proximity/common';
import { ProximityMapContext } from '@rimbu/proximity/map-custom';
function createProximityMapContext(options) {
    return Object.freeze(new ProximityMapContext(options?.distanceFunction ?? DistanceFunction.defaultFunction, options?.hashMapContext ?? HashMap.defaultContext()));
}
const _defaultContext = createProximityMapContext();
export const ProximityMap = Object.freeze({
    ..._defaultContext,
    createContext: createProximityMapContext,
    defaultContext() {
        return _defaultContext;
    },
});
//# sourceMappingURL=index.mjs.map